export default __webpack_public_path__ + "static/media/IMG_1974.7195c62b.jpg";